import React, { useState, useEffect } from "react";
import HostTable from "./HostTable";

export default function Host(props) {
  window.sessionStorage.removeItem("userdata");
  const [hostlist, setlists] = useState([]);
  useEffect(() => {
    window.sessionStorage.setItem("HostName", hostlist.platform);
    let isMounted = true;

    fetch(
      `${process.env.REACT_APP_API_URL}/api/organizationconnectedhostlist/`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + window.localStorage.getItem("token"),
        },
      }
    )
      .then((resp) => resp.json())
      .then((resp) => setlists(resp))
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, []);

  const unique = [
    ...new Set(
      hostlist.sort((a, b) => (a.serial_number > b.serial_number ? -1 : 1))
    ),
  ];

  const [searchitems, setSearchItems] = React.useState(0);

  return (
    <>
      <form className="md:flex hidden flex-row flex-wrap items-center lg:ml-auto mr-3">
        <div className="relative flex flex-wrap items-stretch">
          <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
            <i className="fas fa-search"></i>
          </span>
          <input
            type="text"
            placeholder="Search Hostname here..."
            onChange={(event) => {
              console.log(event.target.value);
              setSearchItems(event.target.value);
            }}
            className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:ring w-full pl-10"
          />
        </div>
      </form>
      <br />
      <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0">
        <HostTable customers={unique} searchitems={searchitems} />
      </div>
    </>
  );
}